__turbopack_context__.v({
  "avatar": "NavbarWorkspaceSwitcher-module-scss-module__cUVkqG__avatar",
  "avatarWrapper": "NavbarWorkspaceSwitcher-module-scss-module__cUVkqG__avatarWrapper",
  "chevron": "NavbarWorkspaceSwitcher-module-scss-module__cUVkqG__chevron",
  "company": "NavbarWorkspaceSwitcher-module-scss-module__cUVkqG__company",
  "container": "NavbarWorkspaceSwitcher-module-scss-module__cUVkqG__container",
  "isOpen": "NavbarWorkspaceSwitcher-module-scss-module__cUVkqG__isOpen",
  "label": "NavbarWorkspaceSwitcher-module-scss-module__cUVkqG__label",
  "name": "NavbarWorkspaceSwitcher-module-scss-module__cUVkqG__name",
  "nudgeDot": "NavbarWorkspaceSwitcher-module-scss-module__cUVkqG__nudgeDot",
  "text": "NavbarWorkspaceSwitcher-module-scss-module__cUVkqG__text",
  "trigger": "NavbarWorkspaceSwitcher-module-scss-module__cUVkqG__trigger",
});
